// components/admin/FullAccessModal.tsx
import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import { User } from "../../context/types";
import useStyles from "../CreativeRequest/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 1,
};

interface FullAccessModalProps {
  user: User;
  onClose: () => void;
  onSubmit: (
    expiresAt?: Date,
    trialCredits?: number,
    trialCreditsVideoAgent?: number,
    trialCreditsPromptToVideo?: number,
  ) => void;
}

export const FullAccessModal: React.FC<FullAccessModalProps> = ({
  user,
  onClose,
  onSubmit,
}) => {
  const [expiresAt, setExpiresAt] = useState<string>("");
  const [trialCredits, setTrialCredits] = useState<number>(0);
  const [trialCreditsVideoAgent, setTrialCreditsVideoAgent] = useState<number>(0);
  const [trialCreditsPromptToVideo, setTrialCreditsPromptToVideo] = useState<number>(0);
  const classes = useStyles();

  const handleSubmit = () => {
    const expirationDate = expiresAt ? new Date(expiresAt) : undefined;
    onSubmit(
      expirationDate,
      trialCredits,
      trialCreditsVideoAgent,
      trialCreditsPromptToVideo,
    );
  };

  return (
    <Modal open onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" gutterBottom mb={2}>
          Grant Full Access to {user.name}
        </Typography>

        <Stack spacing={2}>
          <TextField
            label="Expiration Date"
            type="datetime-local"
            InputLabelProps={{ shrink: true }}
            value={expiresAt}
            onChange={(e) => setExpiresAt(e.target.value)}
            fullWidth
            slotProps={{
              inputLabel: {
                classes: { root: classes.inputLabel },
                shrink: true,
              },
            }}
          />

          <Typography variant="caption" color="text.secondary">
            Each engine has its own bucket. 0 = unlimited for that engine.
          </Typography>

          <TextField
            label="Trial Credits — HeyGen / Avatar Videos"
            type="number"
            value={trialCredits}
            onChange={(e) => setTrialCredits(Number(e.target.value))}
            fullWidth
            inputProps={{ min: 0 }}
            slotProps={{
              inputLabel: {
                classes: { root: classes.inputLabel },
                shrink: true,
              },
            }}
          />

          <TextField
            label="Trial Credits — Video Agent"
            type="number"
            value={trialCreditsVideoAgent}
            onChange={(e) => setTrialCreditsVideoAgent(Number(e.target.value))}
            fullWidth
            inputProps={{ min: 0 }}
            slotProps={{
              inputLabel: {
                classes: { root: classes.inputLabel },
                shrink: true,
              },
            }}
          />

          <TextField
            label="Trial Credits — Prompt to Video"
            type="number"
            value={trialCreditsPromptToVideo}
            onChange={(e) => setTrialCreditsPromptToVideo(Number(e.target.value))}
            fullWidth
            inputProps={{ min: 0 }}
            slotProps={{
              inputLabel: {
                classes: { root: classes.inputLabel },
                shrink: true,
              },
            }}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSubmit}>
              Grant Access
            </Button>
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
};
